interface TrackingList {
  eventFamily: string;
  eventAction: string;
  operationId: string;
  flushImmediately: boolean;
  eventProperty: {
    sid: string;
  };
  actionKind?: string;
}

const triggerTracking = (linkId: any, addActionKind: boolean = true) => {
  const triggerTracking = (window as any)?.triggerTracking;
  if (triggerTracking) {
    const pageId = (window as any).$ebay?.tracking?.pageId;
    const trackingList: TrackingList = {
      eventFamily: "IDENTITY",
      eventAction: "ACTN",
      actionKind: "CLICK",
      operationId: pageId,
      flushImmediately: true,
      eventProperty: {
        sid: `p${pageId}.l${linkId}`,
      },
    };
    if (!addActionKind) {
      delete trackingList.actionKind;
    }
    if (trackingList.actionKind) {
      triggerTracking("pulsar", [
        trackingList,
        { actionKind: trackingList.actionKind },
      ]);
    } else {
      triggerTracking("pulsar", trackingList);
    }
  }
};

export { triggerTracking };
